import "./AvailablePackages.scss";
import SinglePacket from "features/users/PacketModal/components/ChoosePacketStep/SinglePacket";
import { HOME_SCROLL_ENUM, PACKET_ENUM } from "enums";
import React, { useState } from "react";
import { Button } from "shared";
export type ParentType = "payment" | "homepage";

interface AvailablePackagesProps {
  setModalManage: React.Dispatch<React.SetStateAction<"packet" | null>>;
}
const AvailablePackages: React.FC<AvailablePackagesProps> = ({
  setModalManage,
}) => {
  const [selectedPacket, setSelectedPacket] = useState<PACKET_ENUM | null>(
    null
  );

  const handlePacketChange = async (packet: PACKET_ENUM) => {
    setModalManage("packet");
    sessionStorage.setItem("packageFromHome", packet);
    sessionStorage.setItem("packet", packet);

    setTimeout(() => {
      setSelectedPacket(null);
      sessionStorage.removeItem("packageFromHome");
    }, 100);
  };

  return (
    <section className="available-packages">
      <div className="layout" id={HOME_SCROLL_ENUM.PRICE}>
        <h2>Dostępne pakiety</h2>
        <p>
          Nasza aplikacja oferuje aż cztery pakiety, które można dostosować do
          indywidualnych potrzeb inwestorów.
        </p>
        <div className="choose-packet-step__wrapper">
          <div className="choose-packet-step">
            <SinglePacket
              packetName={PACKET_ENUM.BASIC}
              currentPacket={null}
              selectedPacket={selectedPacket}
              setSelectedPacket={setSelectedPacket}
              parent={"homepage"}
            />
            <SinglePacket
              packetName={PACKET_ENUM.STANDARD}
              currentPacket={null}
              selectedPacket={selectedPacket}
              setSelectedPacket={setSelectedPacket}
              parent={"homepage"}
            />
            <SinglePacket
              packetName={PACKET_ENUM.PREMIUM}
              currentPacket={null}
              selectedPacket={selectedPacket}
              setSelectedPacket={setSelectedPacket}
              parent={"homepage"}
            />
            <SinglePacket
              packetName={PACKET_ENUM.PRO}
              currentPacket={null}
              selectedPacket={selectedPacket}
              setSelectedPacket={setSelectedPacket}
              parent={"homepage"}
            />
          </div>
          <div
            className={`choose-packet-step__submit-buttons ${
              !!selectedPacket ? "choose-packet-step__submit-buttons--show" : ""
            }
          choose-packet-step__submit-buttons--right
          choose-packet-step__submit-buttons--homepage
          `}
          >
            <Button
              className="button--rounded button--black button--stroke choose-packet-step__button"
              label="Dalej"
              onClick={() =>
                selectedPacket && handlePacketChange(selectedPacket)
              }
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AvailablePackages;
